<template>
  <span />
</template>

<script>
import isArray from 'lodash/isArray';

export default {
  name: 'Sm3dFan',
  props: {
    points: Array
  },
  data() {
    return {
      sharedState: window.store.state
    };
  },

  // 监听viewer
  computed: {
    isInitViewer: function() {
      return this.sharedState.isInitViewer;
    }
  },
  methods: {
    init() {
      if (this.inited) return;

      var fanUrl = `${process.env.VUE_APP_URL}/3d/data/Fan.s3m`;
      var pillarUrl = `${process.env.VUE_APP_URL}/3d/data/Pillar.s3m`;
      var keymap = {};
      keymap[fanUrl] = [];
      keymap[pillarUrl] = [];
      const { scene, Cesium, viewer } = window;
      var layer = new Cesium.DynamicLayer3D(scene._context, [
        fanUrl,
        pillarUrl
      ]);
      layer.updateInterval = 500; //动态图层更新时间
      layer.enableLocalOffset = false; //禁止模型局部偏移
      scene.primitives.add(layer);
      var points = this.points;
      for (var i = 0; i < points.length; i++) {
        var point = points[i];

        let { coordinates, type } = point;
        console.log('xxx', type);
        if (isArray(point)) {
          coordinates = point;
          type = 'turbine';
        }
        var fanState = new Cesium.DynamicObjectState({
          id: i,
          longitude: coordinates[0],
          latitude: coordinates[1],
          altitude: coordinates[2],
          scale: new Cesium.Cartesian3(1, 1, 1),
          offset: new Cesium.Cartesian3(0, 0, 690)
        });
        keymap[fanUrl].push(fanState);
        var pillarState = new Cesium.DynamicObjectState({
          id: i,
          longitude: coordinates[0],
          latitude: coordinates[1],
          altitude: coordinates[2],
          scale: new Cesium.Cartesian3(1, 1, 1)
        });
        keymap[pillarUrl].push(pillarState);
        for (var key in keymap) {
          layer.updateObjectWithModel(key, keymap[key]);
        }
      }

      const getHeight = () => {
        var scene = viewer.scene;
        var ellipsoid = scene.globe.ellipsoid;
        var height = ellipsoid.cartesianToCartographic(viewer.camera.position)
          .height;
        return height;
      };
      let lastScale = 0;

      var fanArr = keymap[fanUrl];
      var pillarArr = keymap[pillarUrl];
      setInterval(function() {
        const height = getHeight();
        let scale = height / 10000;
        if (scale < 0.1) {
          scale = 0.1;
        } else if (scale > 30) {
          scale = 50;
        }

        if (fanArr.length > 0) {
          for (var i = 0; i < fanArr.length; i++) {
            if (fanArr[i].pitch > 10000) {
              fanArr[i].pitch = 0;
            }
            fanArr[i].pitch += Math.PI;
            if (scale !== lastScale) {
              fanArr[i].scale = new Cesium.Cartesian3(scale, scale, scale);
              pillarArr[i].scale = new Cesium.Cartesian3(scale, scale, scale);
            }
          }
          lastScale = scale;
          layer.updateObjectWithModel(fanUrl, fanArr);
          layer.updateObjectWithModel(pillarUrl, pillarArr);
        } else return;
      }, 500);
      this.inited = true;
    },
    clear() {}
  },
  watch: {
    isInitViewer() {
      this.init();
    }
  },
  mounted() {
    if (this.isInitViewer) {
      this.init();
    }
  }
};
</script>
<style lang="less" scoped></style>
